"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  rpc: {},
  types: {
    NomineeId: 'AccountId',
    HomaUnlockChunk: {
      value: 'Balance',
      era: 'EraIndex'
    },
    BondingLedger: {
      total: 'Balance',
      active: 'Balance',
      unlocking: 'Vec<HomaUnlockChunk>'
    }
  },
  typesAlias: {
    nomineesElection: {
      UnlockChunk: 'HomaUnlockChunk'
    }
  }
};
exports.default = _default;